define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function ($, _, Marionette, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {},

        events: {},

        initialize: function () {
            this.bindUIElements();

            if (window.form_error) {
                this.triggerMethod('show:errors', window.form_error);
                window.form_error = null;
            }
        },
    });
});